import { deleteLayer } from '@/legacy/components/apps/ClientModalProvider';
import type { BaseProps } from '@/legacy/components/base/utils';
import LButton from '@/legacy/components/btn/LButton';
import ProfileImageV2 from '@/legacy/components/img/Profilev2';
import styles from '@/legacy/components/modalContents/businessGrant.module.scss';
import { KEBAB_KEY } from '@/legacy/components/modalContents/KebabModal';
import { useGetGeneralUser } from '@/model/dexie/ownerDexie';
import { promiseNotNullCheck } from '@/utilities/stateTool';
import { useTransCommon } from '@/@shared/hooks/useTranslations';

type Props = {
	closeFn?: BaseProps['button']['onClick'];
	applyFn?: BaseProps['button']['onClick'];
};

export const LOGOUT_MODAL_KEY = 'LOGOUT_MODAL_KEY';

const LogoutModal = ({ closeFn, applyFn }: Props) => {
	const t = useTransCommon('temp.modal');
	const menu = useTransCommon('temp.modal');
	const user = useGetGeneralUser();

	if (promiseNotNullCheck(user))
		return (
			<div className={styles.wrap}>
				<ProfileImageV2 size={64} src={user.profileImageUrl} type="COMMON" />

				<h2 className={styles.title}>{menu('logout')}</h2>
				<hr className={styles.hr} />
				<span className={styles.description}> {t('confirmLogout')}</span>

				<div className={styles.buttons}>
					<LButton
						buttonType="button"
						color="gray"
						onClick={(e) => {
							deleteLayer(LOGOUT_MODAL_KEY);
							deleteLayer(KEBAB_KEY);
							closeFn && closeFn(e);
						}}
					>
						{menu('cancel')}
					</LButton>
					<LButton buttonType="button" color="purple" onClick={applyFn}>
						{menu('logout')}
					</LButton>
				</div>
			</div>
		);
};

export default LogoutModal;
